import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const HeaderValue = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(0.2),
}));
